import { ReactElement } from 'react';
import DallasSvgIcon from '../../Icons/DallasSvgIcon';
import DallasButton, {
  Props as DallasButtonProps,
} from '../DallasButton/DallasButton';
import DallasTooltipAnchor from '../../Tooltip/DallasTooltipAnchor';

export interface Props
  extends Omit<
    DallasButtonProps,
    'label' | 'flex' | 'addOnStart' | 'addOnEnd'
  > {
  /**
   * DallasSvgIcon element at the center position of the button
   */
  icon: ReactElement<typeof DallasSvgIcon>;
  /**
   * Accessibility label for the current button.
   */
  'aria-label': string;
}

export default function DallasIconButton({
  icon,
  ['aria-label']: ariaLabel,
  ...buttonProps
}: Props) {
  return (
    <DallasTooltipAnchor
      tooltip={ariaLabel}
      tooltipType="label"
      aria-label={ariaLabel}
      render={({ color: _, onClick: _onClick, ...props }) => (
        <DallasButton {...props} {...buttonProps} addOnStart={icon} />
      )}
    />
  );
}
